import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { Link, useParams } from 'react-router-dom';
import { CaretLeftIcon, XIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getArea } from 'api/areas';
import Button from 'components/Button';
import OfficeAddUserPopup from 'components/Offices/OfficeAddUserPopup';

export default function Area() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const [searchUsers, setSearchUsers] = useState('');
    const [addUserPopup, setAddUserPopup] = useState(false);
    const [addOfficePopup, setAddOfficePopup] = useState(false);
    const { areaId } = useParams();

    const { data: area } = useQuery({
        queryKey: ['areas', areaId],
        queryFn: async () => await getArea({id: areaId}),
    });

    function removeUserHandler(id) {
        console.log('remove user', id);
    }

    function removeOfficeHandler(id) {
        console.log('remove office', id);
    }

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='pb-20'>
                    <div className='pb-8 pt-20 md:pt-14 flex gap-3 items-center'>
                        <Link to="/settings/areas" className=''>
                            <CaretLeftIcon size={26} className='hover:text-muted' />
                        </Link>
                        <p className='text-3xl'>{area?.name}</p>
                    </div>

                    <div className='flex justify-between items-center'>
                        <p className='text-muted text-lg'>Uffici collegati</p>
                        <Button onClick={() => setAddOfficePopup(true)}>
                            Collega ufficio
                        </Button>
                    </div>

                    <div className='border border-light rounded-sm mt-5 mb-10'>
                        {(!area?.offices || area?.offices?.length === 0) && (
                            <div className='p-4'>
                                <p className='text-muted'>Nessun ufficio collegato a questa area.</p>
                            </div>
                        )}
                        {area?.offices?.map((office, index) => {
                            return (
                                <div key={index} className=' group border-b last:border-0 border-light flex items-center gap-4 p-4'>
                                    <div className='flex-1'>
                                        <p className='font-semibold'>{office.name}</p>
                                    </div>

                                    <div className='opacity-0 group-hover:opacity-100 flex-1 flex gap-4 justify-end items-center'>
                                        <Link to={`/settings/offices/${office._id}`} className='hover:underline'>
                                            Vedi dettagli
                                        </Link>

                                        <div className='hover:text-red-400 hover:underline cursor-pointer' onClick={() => removeOfficeHandler(office._id)}>
                                            Rimuovi
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <p className='text-muted text-lg'>Utenti collegati</p>

                    <div className='w-full flex justify-between items-center pt-5'>
                        <form>
                            <input  
                                type="text"
                                placeholder='Cerca utenti...'
                                className='w-full bg-white border border-light text-sm rounded-sm focus:ring-0 focus:outline-none focus:border-grey placeholder:text-muted px-4 py-3 min-w-[400px] w-[400px] block'
                                onChange={(e) => setSearchUsers(e.target.value)}
                            />
                        </form>
                    </div>

                    <div className='border border-light rounded-sm mt-6'>
                        {area?.users?.filter(user => {
                            return user.firstname.toLowerCase().includes(searchUsers.toLowerCase()) || user.lastname.toLowerCase().includes(searchUsers.toLowerCase());
                        }).map((user, index) => {
                            return (
                                <div key={index} className=' group border-b last:border-0 border-light flex items-center gap-4 p-4'>
                                    <div className='flex-1'>
                                        <p className='font-semibold'>{user.firstname} {user.lastname}</p>
                                    </div>
                                    <div className='flex-1'>
                                        <p className='text-muted'>{user.offices?.join(', ')}</p>
                                    </div>

                                    <div className='opacity-0 group-hover:opacity-100 flex-1 flex gap-4 justify-end items-center'>
                                        <Link to={`/settings/users/${user._id}`} className='hover:underline'>
                                            Vedi profilo
                                        </Link>

                                        <div className='hover:text-red-400 hover:underline cursor-pointer' onClick={() => removeUserHandler(user._id)}>
                                            Rimuovi
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </Container>
            </div>

            <OfficeAddUserPopup
                visible={addOfficePopup}
                setVisible={setAddOfficePopup}
            />

            <div className={`fixed top-0 left-0 w-full h-full bg-black/90 bg-opacity-50 z-[var(--z-modal)] transition-all duration-300 ${addUserPopup ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
                <div className='bg-black rounded-sm border border-greylight w-full max-w-lg mx-4 md:mx-auto mt-40 p-6'>
                    <div className='flex justify-between items-center pb-4'>
                        <p className='text-white text-lg font-semibold'>{`Aggiungi utente all'area`}</p>
                        <div onClick={() => setAddUserPopup(false)} className='cursor-pointer text-light hover:text-white'>
                            <XIcon size={20} />
                        </div>
                    </div>

                    <form>
                        <div className='mb-4'>
                            <label className='block text-white mb-2' htmlFor="user">Utente</label>
                            <select className='w-full bg-grey text-white text-sm rounded-sm focus:ring-0 focus:outline-none focus:border-grey placeholder:text-light px-4 py-3 block'>
                                <option value="">Seleziona un utente</option>
                                <option value="1">Mario Rossi</option>
                                <option value="2">Luigi Verdi</option>
                                <option value="3">Anna Bianchi</option>
                            </select>
                        </div>

                        <div className='flex justify-between gap-4 mt-6'>
                            <div onClick={() => setAddUserPopup(false)} className=' text-light hover:bg-greydark hover:text-white cursor-pointer px-4 py-3 text-sm rounded-sm'>
                                Annulla
                            </div>
                            <div className='bg-white font-medium cursor-pointer text-black px-4 py-3 text-sm rounded-sm hover:bg-white/85'>
                                Conferma
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
